import { useEffect, useRef } from "react";

export const useBlocker = (blocker, when) => {
  const isBlocked = useRef(false);

  useEffect(() => {
    if (!when) return;

    const handleBeforeUnload = (e) => {
      if (when) {
        const message =
          "You have unsaved changes. Are you sure you want to leave?";
        e.preventDefault();
        e.returnValue = message;
        return message;
      }
    };

    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => window.removeEventListener("beforeunload", handleBeforeUnload);
  }, [when]);

  // Block navigation attempts
  useEffect(() => {
    if (!when) return;

    const originalPushState = window.history.pushState;
    const originalReplaceState = window.history.replaceState;

    window.history.pushState = function (state, title, url) {
      if (when && !isBlocked.current) {
        isBlocked.current = true;
        blocker({ action: "PUSH", location: { pathname: url } });
        return;
      }
      return originalPushState.apply(this, arguments);
    };

    window.history.replaceState = function (state, title, url) {
      if (when && !isBlocked.current) {
        isBlocked.current = true;
        blocker({ action: "REPLACE", location: { pathname: url } });
        return;
      }
      return originalReplaceState.apply(this, arguments);
    };

    return () => {
      window.history.pushState = originalPushState;
      window.history.replaceState = originalReplaceState;
    };
  }, [when, blocker]);

  return {
    proceed: () => {
      isBlocked.current = false;
    },
    reset: () => {
      isBlocked.current = false;
    },
  };
};
